import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";


export class SubDepartment extends EntityDto implements IEntityDto {
  SubDepartment_Id: string;
  SubDepartmentName: string;
  SubDepartmentPrefix:string; 
  Company_Id: string;
  CompanyName: string;
  Division_Id: string;
  DivisionName: string;
  Location_Id: string;
  LocationName: string;
  Department_Id: string;
  DepartmentName: string;
  TotalCount: number;
  IsActive: boolean;
  Emp_Ref_Id: string;
  EmployeeName: string;

  constructor() {
    super();
    this.SubDepartment_Id = '00000000-0000-0000-0000-000000000000';
    this.SubDepartmentName = ''; 
    this.SubDepartmentPrefix = '';
    this.Company_Id = "";
    this.CompanyName = "";
    this.Division_Id = "";
    this.DivisionName = "";
    this.Location_Id = '';
    this.LocationName = '';
    this.Department_Id = ''; 
    this.DepartmentName = '';
    this.TotalCount = 0;
    this.IsActive = true;
    this.Emp_Ref_Id = '';
    this.EmployeeName = '';

    this.EntityMetaData = [
      { FieldName: 'SubDepartmentName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Sub Department Name is required' },
      { FieldName: 'SubDepartmentPrefix', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
      
      //{FieldName : 'Department_Id' , FieldType: FieldType.String, IsMandatory:true, ValidationMessage: 'Department is required'},
      //{ FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Sub Department Head is required' },
      
   ];
  } 
}